import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const Modal = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border-radius: 8px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

export const ModalContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 24px;
  font-weight: 600;
`;

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.7;
  }
`;

export const PackageSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PackageName = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 600;
`;

export const DiscountBadge = styled.div`
  padding: 4px;
  background: ${({ theme }) => theme.palette.lightGreenScore};
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DiscountText = styled.div`
  color: ${({ theme }) => theme.palette.white};
  font-size: 14px;
  font-weight: 600;
`;

export const PriceCardsContainer = styled.div`
  display: flex;
  padding: 12px;
  background: ${({ theme }) => theme.palette.grey100};
  border-radius: 8px;
  gap: 0;
  overflow-x: auto;
  align-items: stretch;
`;

export const PriceCard = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 150px;
  padding: 0 17px;
`;

export const PriceInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PriceTitle = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const PriceOriginal = styled.div`
  color: ${({ theme }) => theme.palette.grey700};
  font-size: 14px;
  font-weight: 600;
  text-decoration: line-through;
`;

export const PriceValue = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 20px;
  font-weight: 700;
`;

export const PriceNote = styled.div`
  color: ${({ theme }) => theme.palette.grey700};
  font-size: 12px;
  font-weight: 400;
`;

export const PriceLabel = styled.div`
  color: ${({ theme }) => theme.palette.grey700};
  font-size: 12px;
  font-weight: 400;
  margin-top: 8px;
`;

export const Separator = styled.div`
  width: 1px;
  align-self: stretch;
  background: ${({ theme }) => theme.palette.grey300};
  margin: 0;
`;
